<ng-template #rowNumberTemplate
  let-index="index"
  let-pagination="pagination">
  {{ pagination ? pagination.page * pagination.size + index + 1 : index + 1 }}
</ng-template>
